"use client";

import { AlertCircleIcon, ChevronRight } from "lucide-react";
import Link from "next/link";
import { useSearchParams } from "next/navigation";
import { useMemo, useState } from "react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";

export function ForwardProductionAlert() {
  const searchParams = useSearchParams();

  const [isProduction, setIsProduction] = useState(false);

  useMemo(() => {
    if ("window" in globalThis) {
      if (window.location?.host) {
        setIsProduction(window.location.host === "ai-roleplay.jp");
      }
    }
  }, []);

  if (isProduction) {
    return null;
  }

  return (
    <Alert variant="destructive">
      <AlertCircleIcon />
      <AlertTitle>サーバーを変更しましたので、</AlertTitle>
      <AlertDescription>
        <Button
          asChild
          variant="ghost"
          size="sm"
          className="flex justify-between items-center gap-2 border-destructive/50">
          <Link
            href={["https://ai-roleplay.jp/sign-in", `?${searchParams}`].join(
              "",
            )}>
            ご利用中のお客様はこちらから
            <ChevronRight />
          </Link>
        </Button>
      </AlertDescription>
    </Alert>
  );
}
